import React, { useEffect, useState, useRef } from 'react';
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom';
import { useRouter } from './components';
import { StoreProvider } from './store';
import { ViewPage } from './cms/pages/viewPage/viewPage';
import { EditPage } from './cms/pages/editPage/editPage';
import { TopHeader } from './layout/topHeader/topHeader2';
// import { Footer } from './layout/footer/footer';
import { BottomDock } from './layout/bottomDock/bottomDock';
// import { BlogView } from './site/blog/blogView';
import { AppVersionPage } from './components';
import { MediaQueryStatus } from './components';
import { CommonVideoPopup } from "./layout/popup/commonVideoPopup";
import { HelmetProvider } from 'react-helmet-async';
//import { useScrollPosition } from '@n8tb1t/use-scroll-position';
import { AppRouteChanged } from './AppRouteChanged';
import AOS from 'aos';
import { onMessageListener, isSafari } from './cms/utils/firebaseUtils';
import NotificationPermission from './components/notification/NotificationPermission';
import NotificationBar from './components/notification/NotificationBar';

//For ECM
import { ProductView } from './site/ecm/product/productView';
import { OrderDetails } from './site/ecm/orderDetails/orderDetails';
import { LiveFeedCheckout } from './site/ecm/liveFeedCheckout/liveFeedCheckout';
import { WatchPage } from './site/ecm/watch/WatchPage';
import { OrderHistoryPage } from './site/ecm/orderHistory/OrderHistoryPage';
import { MemberDashboard } from './site/ecm/memberDashboard/MemberDashboard';
import env from './env';
import { useStore } from './store';

// For Auth (ABNA-style login system)
import { ProvideAuth } from './auth';
import { Login, Signup, ForgotPassword, ResetPassword } from './auth';
import { RequireAuth } from './components';

function AppLayout(props) {
  const { pathname } = useRouter();

  const [fcmToken, setFcmToken] = useState(null);

  const handleTokenReceived = (token) => {
    setFcmToken(token);
    console.log("FCM Token received:", token);
  };

  // Helper function to show notification
  const showNotification = (title, body, data = {}) => {
    if ('Notification' in window && Notification.permission === 'granted') {
      const notification = new Notification(title, {
        body: body,
        icon: '/favicon.ico',
        badge: '/favicon.ico',
        data: data,
        requireInteraction: true
      });

      // Handle notification click
      notification.onclick = (event) => {
        event.notification.close();
        if (data.url) {
          window.open(data.url, '_blank');
        } else {
          window.focus();
        }
      };
    }
  };

  useEffect(() => {
    // listen to foreground messages - DISABLED to prevent duplicate notifications
    // All notifications are handled by service worker only
    /*
    onMessageListener().then((payload) => {
      console.log('[App] Received foreground message:', payload);
      
      // Handle foreground messages - only for UI updates, not notifications
      if (payload.notification) {
        console.log('Notification Title:', payload.notification.title);
        console.log('Notification Body:', payload.notification.body);
        
        // Don't show notification in frontend - let service worker handle all notifications
        // This prevents duplicate notifications
        console.log('[App] Skipping notification display - handled by service worker');
      }
      
      if (payload.data) {
        console.log('Message Data:', payload.data);
        // Handle custom data for UI updates if needed
        // You can add UI updates here without showing notifications
      }
    }).catch((err) => {
      console.error('Error listening to foreground messages:', err);
    });
    */
    
    // Completely disabled foreground message listener to prevent duplicate notifications
    console.log('[App] Foreground message listener disabled - all notifications handled by service worker');
  }, []);

  //For ECM
  const storeContext = useRef(useStore());

  //const [scrolled, setScrolled] = useState(false)
  //const path = usePath();
  //const routeResult = useRoutes(routes);

  // const parallax = useParallax();
  // //console.log(path, routeResult);
  // const routeChanged = (path) => {
  //   //console.log(path);
  //   parallax.reset();
  // }

  // useScrollPosition(({ prevPos, currPos }) => {
  //   //console.log(currPos.x)
  //   //console.log(currPos.y);
  //   if (currPos.y > 90) {
  //     document.querySelector('body').classList.add('scrolled')
  //   } else {
  //     document.querySelector('body').classList.remove('scrolled')
  //   }
  //   //setScrolled(currPos.y > 90)
  // }, [], null, true)

  //const pageChanged = useCallback(path => routeChanged(path), [])
  //useLocationChange((path) => { routeChanged(path, history)})
  //useLocationChange(path => routeChanged(path))

  //const pathFiltered = (pathname || '').toLocaleLowerCase();
  let specialClassName = '';
  //  if (pathFiltered.indexOf('/digital-sensor') >= 0) specialClassName = 'digital-sensor-page';
  //  else if (pathFiltered === '/brilliance') specialClassName = 'brilliance-page';

  useEffect(() => {
    AOS.init({
      duration: 1200
      //delay:400,
      //once:true
    });

    // For ECM
    fetch(env.apiBase + "/api/cart/getcart/" + env.getDevCartId())
      .then(res => res.json())
      .then(res => {
          const data = res;
          if(data){
            storeContext.current.dispatch({type:'SET_STATE', payload : {cartInfo : data.cartInfo.totalQuantity === 0 ? 0 : (data.cartInfo.totalQuantity)-1}});
          }
      })
      .catch(error =>{
        storeContext.current.dispatch({type:'SET_STATE', payload : {cartInfo : 0}});
    });

  }, []);

  return (
    <div className={`body-content ${pathname === '/' ? 'homepage' : 'subpage'} ${specialClassName}`}>
      <AppRouteChanged />
      <NotificationBar onTokenReceived={handleTokenReceived} />
      <NotificationPermission onTokenReceived={handleTokenReceived} />
      <TopHeader></TopHeader>
      <div className="main-content">
        <div className="app-content">
          <Switch>
            <Route path="/ver" children={<AppVersionPage />} />
            <Route path="/cms/page/render/:id" children={<EditPage />} />
            <Route path="/login" children={<Login />} />
            <Route path="/sign-up" children={<Signup />} />
            <Route path="/forgot-password" children={<ForgotPassword />} />
            <Route path="/auth/reset-password" children={<ResetPassword />} />

            <RequireAuth path="/members-area/my-account" component={MemberDashboard} redirectTo="/login" />
            <RequireAuth path="/members-area" component={MemberDashboard} redirectTo="/login" />
            <RequireAuth path="/member-area" component={MemberDashboard} redirectTo="/login" />

            <Route path="/admin">
              <Redirect to="/admin" />
            </Route>

            {/* For ECM  */}
            <Route path="/order-thankyou" children = {<OrderDetails />}/>
            <Route path="/checkout/live-feed" children={<LiveFeedCheckout />} />
            <Route path="/watch" children={<WatchPage />} />
            <RequireAuth path="/account/orders" component={OrderHistoryPage} redirectTo="/login" />
            <Route path="/product/:slug" children = {<ProductView />}/>

            <Route path="/">
              <ViewPage />
            </Route>
          </Switch>
        </div>
        {/* <app-common-bottom-partial></app-common-bottom-partial> */}
      </div>
      {/* <Footer></Footer> */}
      <BottomDock></BottomDock>
      <MediaQueryStatus />
      <CommonVideoPopup />
    </div>
  );
}

function App() {
  return (
    <StoreProvider>
      <HelmetProvider>
        <Router>
          <ProvideAuth>
            <AppLayout />
          </ProvideAuth>
        </Router>
      </HelmetProvider>
    </StoreProvider>
  );
}

export default App;